import * as React from 'react';
// TODO (kyle): figure out how to code split this

import {AsYouType} from 'libphonenumber-js';

import ErrorInput from 'src/components/lib/error-input/index';


type Props = {
  onChange: (
    value: string,
    meta: {
      country: string;
    },
  ) => Promise<undefined> | undefined;
  value: string;
  defaultCountry?: string;
  placeholder?: string;
  disabled?: unknown;
  onEnterKeyDown?: () => unknown;
  autoFocus?: unknown;
};

export default function PhoneInput({
  defaultCountry = 'US',
  value,
  onChange,
  onEnterKeyDown,
  ...props
}: Props) {
  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const inputRef = React.useRef<HTMLInputElement | null | undefined>();
  const selectionIndex = React.useRef<number>(0);

  // NOTE (kyle): we always parse the value to avoid displaying
  // normalized numbers.
  const [phoneValue, displayValue] = React.useMemo(() => {
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'CountryCode | { defaultCountry?: CountryCode | undefined; defaultCallingCode?: string | undefined; } | undefined'.
    const phoneValue = new AsYouType(defaultCountry);
    const displayValue = phoneValue.input(value || '');
    return [phoneValue, displayValue];
  }, [value, defaultCountry]);

  // NOTE (kyle): whenever the value changes, we must adjust the
  // cursor position so that it accounts for any characters that may
  // have been added.
  React.useLayoutEffect(() => {
    const target = inputRef.current;

    if (!target) {
      return;
    }

    const template = phoneValue.getTemplate();

    let displayIndex = 0;
    if (template) {
      for (let i = 0, j = 0; i < displayValue.length; i++) {
        if (template[i] === 'x') {
          j++;
        }
        if (j > selectionIndex.current) {
          displayIndex = i + 1;
          break;
        }
      }
    } else {
      displayIndex = selectionIndex.current + 1;
    }

    target.selectionStart = displayIndex;
    target.selectionEnd = displayIndex;
  }, [phoneValue, displayValue]);

  // NOTE (kyle): when the input value changes, we parse that value and then
  // resulting normalized phone number (without locale characters) to the
  // parent.
  const updateValue = React.useMemo(
    () => (value: string, target: HTMLInputElement) => {
      const {selectionStart} = target;

      // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'CountryCode | { defaultCountry?: CountryCode | undefined; defaultCallingCode?: string | undefined; } | undefined'.
      const phoneValue = new AsYouType(defaultCountry);
      phoneValue.input(value);
      const newValue = phoneValue.getChars(); // normalized phone number

      // we cache the current cursor position here.
      selectionIndex.current =
        // @ts-expect-error - TS2345 - Argument of type 'number | null' is not assignable to parameter of type 'number | undefined'.
        value.slice(0, selectionStart).replace(/[^+\d]/g, '').length - 1;

      // @ts-expect-error - TS2345 - Argument of type 'AsYouType' is not assignable to parameter of type '{ country: string; }'.
      onChange(newValue, phoneValue);
    },
    [onChange, selectionIndex],
  );

  const handleChange = React.useMemo(
    () =>
      ({target}: React.ChangeEvent<HTMLInputElement>) => {
        updateValue(target.value, target);
      },
    [updateValue],
  );

  // NOTE (kyle): Backspacing is a special case because backspacing a special
  // character reflects an intent to backspace the last numeric character
  // before it. This allows a user to continuously backspace over the entire
  // string.
  const handleKeyDown = React.useMemo(
    () => (event: React.KeyboardEvent<HTMLInputElement>) => {
      const {key} = event;
      if (key === 'Backspace') {
        const {currentTarget: target} = event;
        const {value, selectionStart, selectionEnd} = target;

        if (selectionStart === selectionEnd) {
          event.preventDefault();

          // @ts-expect-error - TS2345 - Argument of type 'number | null' is not assignable to parameter of type 'number | undefined'.
          const leftSide = value.slice(0, selectionStart);
          let cutPoint = 0;
          for (let i = leftSide.length - 1; i > -1; i--) {
            if (/[+\d]/.test(leftSide[i])) {
              cutPoint = i;
              break;
            }
          }
          const newValue =
            // @ts-expect-error - TS2345 - Argument of type 'number | null' is not assignable to parameter of type 'number | undefined'.
            leftSide.slice(0, cutPoint) + value.slice(selectionStart);
          target.selectionStart = cutPoint;
          updateValue(newValue, target);
        }
      } else if (key === 'Enter' && onEnterKeyDown) {
        onEnterKeyDown();
      }
    },
    [updateValue],
  );

  return (
    // @ts-expect-error - TS2786 - 'ErrorInput' cannot be used as a JSX component.
    <ErrorInput
      {...props}
      // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
      type="tel"
      // @ts-expect-error - TS2322 - Type '({ target }: React.ChangeEvent<HTMLInputElement>) => void' is not assignable to type 'never'.
      onChange={handleChange}
      // @ts-expect-error - TS2322 - Type '(event: React.KeyboardEvent<HTMLInputElement>) => void' is not assignable to type 'never'.
      onKeyDown={handleKeyDown}
      // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
      value={displayValue}
      // @ts-expect-error - TS2322 - Type 'RefObject<HTMLInputElement | null | undefined>' is not assignable to type 'never'.
      inputRef={inputRef}
    />
  );
}
